<script >
  // packages
  import { ascending, descending, index } from 'd3-array';
  import { intcomma, pluralize } from 'journalize';

  // components
  import CandidateRow from './CandidateRow.svelte';
  import CandidateRowHeader from './CandidateRowHeader.svelte';


 /** @type {string} */
  export let raceId
   /** @type {string} */
  export let caption
   /** @type {string | undefined} */
  export let captionNote
 /** @type {string} */
  export let office
   /** @type {string} */
   export let type

 /**
   * @type {import('../types.d').ReadableCandidateLookup}
   */
  export let candidates

  /**
   * @type {import('../types.d').ReadableDelCandidateLookup}
  */
  export let delCandidates;

  /** @type {number} */
  export let totalVotes
  /** @type {number} */
  export let precinctsReportingPercent
 
  export let alwaysShowCandidates = !office == 'P' ? 4 : 2;

  export let shouldSortCandidates = false;
  export let hidePrecincts = false;
  /** @type {number | null} */
  export let eevp
  /** @type {number} */
  export let numOfwinners
  /** @type {boolean} */
  export let face
  
  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  // presidential race dropped out candidates list
  let droppedOutCandidates = [
      'polid-60051',
      'polid-62557',
      'polid-5956',
      'polid-71843',
      'polid-60420'
  ];


  const numberOfCandidates = candidates.length;
  const tooFewToHide = numberOfCandidates <= alwaysShowCandidates + 1;

  let viewAllCandidates = false;

  const hasParties =
    candidates.some(
      (candidate) => candidate.party && candidate.party.length > 0
    ) &&
    !candidates.every(
      (candidate) => candidate.party && candidate.party === 'np'
    );
  
  const isBallotMeasure = office === 'I' || type === 'm' || type === 'Measure' || raceId === '9619-orange' || raceId === '9620-orange';
  const isPresident = office === 'P';

  $:delCandidatesByID = delCandidates ? index(delCandidates, (d) => d.candidate_id) : '';

  $: preppedCandidates = shouldSortCandidates
  ? candidates.sort((a, b) => descending(a.votes, b.votes))
  : candidates

  $: numDecimalsInPercent = raceId === 'GA-S12301-2020-11-03' ? 3 : undefined;

</script>

<div class="contest">
  <table class="contest__candidates">
    {#if caption || captionNote}
      <caption class="contest__caption text-left">
          {#if caption}
          <p>{caption}</p>
          {/if}
          {#if captionNote}
            <p class="m-0"><span class="text-xs text-regular color-grey">{@html captionNote}</span></p>
          {/if}
      </caption>
    {/if}
    <CandidateRowHeader {face} {isBallotMeasure} {isPresident} {hasParties} />
    <tbody>
      {#each preppedCandidates as candidate, idx (candidate.ap_id)}
      <tr
          class="candidate contest__candidate-row contest__candidate-row-{candidate.party}"
          hidden={!(viewAllCandidates || tooFewToHide || idx < alwaysShowCandidates)}>
          <CandidateRow
            familyName={candidate.family_name}
            givenName={candidate.given_name}
            party={candidate.party}
            isWinner={candidate.is_winner}
            isRunoff={candidate.is_runoff}
            isIncumbent={candidate.is_incumbent}
            votes={candidate.votes}
            lookup={face?crosswalk.get(candidate.ap_id):''}
            ca_delegates = {delCandidates?delCandidatesByID.get(candidate.ap_id).ca.pledged_delegates:''}
            {face}
            {numOfwinners}
            {isBallotMeasure}
            {isPresident}
            {hasParties}
            {totalVotes}
            {numDecimalsInPercent} 
            hasDroppedOut = {droppedOutCandidates.includes(candidate.ap_id)}
            ap_id = {candidate.ap_id}
            />
        </tr>
      {/each}
      {#if !tooFewToHide}
        <tr class="candidate contest__candidate-row">
          <th colspan={face?3:2} scope="row" class="candidate__cell view-all">
            <button on:click={() => (viewAllCandidates = !viewAllCandidates)}>
              View
              {viewAllCandidates ? 'fewer' : 'all'}
              candidates
              <svg
                class="icon"
                class:icon-angle-down={!viewAllCandidates}
                class:icon-angle-up={viewAllCandidates}>
                <use
                  xlink:href="#{viewAllCandidates ? 'icon-angle-up' : 'icon-angle-down'}" />
              </svg>
            </button>
          </th>
          <td
          colspan={isPresident ? 3 : 2}
          class="contest__precincts text-right">
          {intcomma(totalVotes)}
          total vote{pluralize(totalVotes)}
        </td>
        </tr>
      {:else}
        <tr class="candidate contest__candidate-row">
          <td
          colspan={4}
          class="contest__precincts text-right">
          {intcomma(totalVotes)}
          total vote{pluralize(totalVotes)}
        </td>
        </tr>
      {/if}
    </tbody>
    <tfoot>
      <tr>
        <td colspan={isPresident ? 6 : face ? 5 : 4} class="contest__precincts text-right">
          {#if !hidePrecincts}
            {#if eevp !== null}
              {eevp}% of expected vote in
            {:else}{precinctsReportingPercent}% precincts reporting{/if}
          {/if}
        </td>
      </tr>
    </tfoot>
  </table>
</div>
